import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../assets/models/tema4/GLB_T4_CPU.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Cpu extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.8, -2.2, -2.6);
		this.scale.set(3, 3, 2);
		this.rotateY(4.7)
		// this.helpers()
	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.CPU = gltf.scene.getObjectByName("CPU", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const cpuFolder = gui.addFolder("CPU");
		cpuFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		cpuFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		cpuFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		cpuFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		cpuFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		cpuFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		cpuFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		cpuFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		cpuFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		cpuFolder.add(this, "visible").name("visible");
	}
	onAnimateCpu() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.CPU
		this.CPU.material.emissive.set("#404040");

		this.animation = gsap.to(this.CPU.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
}